$(function(){
  var myCookie = readCookie('popupOpen');

  //Function to open or close the Pop-Up
  function openPopUp(){
    $(".pop-up,.dark-overlay").fadeIn("slow");
    $(".pop-up").toggleClass("opened");
    createCookie('popupOpen','cookieOpen',7);
  }
  function closePopUp(){
    $(".pop-up,.dark-overlay").fadeOut("slow");
  }
  $(".dark-overlay,.close-btn,.pop-up").click(function(){
    closePopUp();
  });
});
